<template>
    <div>
        <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
                <h2 class="page-title-receipt mb-0">Penerimaan QR</h2>
            </div>
            <div class="d-flex align-items-center">
                <button
                    v-if="canReturn"
                    class="btn btn-outline-pengembalian mr-3"
                    @click="modal.showReturnModal = true"
                >
                    Pengembalian QR
                </button>
                <div class="saldo-qr-text">
                    Saldo QR : <span>{{ saldoQr != null ? numberWithCommas(saldoQr) : '0' }}</span>
                </div>
            </div>
        </div>

        <qrReceiptFromMD
            class="mt-3"
            ref="qrReceiptFromMD"
        ></qrReceiptFromMD>

        <return-qr-modal
            v-if="modal.showReturnModal"
            @closeModal="modal.showReturnModal = false"
            @updateTable="updateTable"
        ></return-qr-modal>
    </div>
</template>

<script>
import moment from 'moment';
import qrReceiptFromMD from './children/qrReceiptFromMD.vue';
import ReturnQrModal from './children/ReturnQRModal.vue';
import { fetchOwnReturnAccess } from '@/services/return-access';

export default {
    metaInfo: {
        title: 'Penerimaan QR'
    },
    components: {
        qrReceiptFromMD,
        ReturnQrModal
    },
    data() {
        let startDate = moment().startOf('month').format("MM-DD-Y");
        let currentDate = moment().format("MM-DD-Y");
        return {
            rangePickr: {
                mode: 'range',
                dateFormat: "m-d-Y",
                altInput: true,
                altInputClass: 'form-control input bg-white h-47px',
                altFormat: 'm-d-Y'
            },
            selected: {
                date: `${startDate} to ${currentDate}`
            },
            saldoQr: 0,
            canReturn: false,
            modal: {
                showReturnModal: false,
            },
        }
    },
    beforeMount() {
        document.getElementById('content').style.background = '#F8F8F8';
    },
    beforeDestroy() {
        document.getElementById('content').style.background = '';
    },
    mounted() {
        this.fetchData();
        this.checkReturnAccess();
    },
    methods: {
        async checkReturnAccess() {
            try {
                this.canReturn = await fetchOwnReturnAccess(this.$http);
            }
            catch (err) {
                // Fail closed: hide the return button when access is unknown.
                this.canReturn = false;
                console.error(err);
            }
        },
        numberWithCommas(x) {
            if (!x && x !== 0) return '0';
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        fetchData() {
            this.$http.get(`/api/qrs/highlight/dealer/saldo`)
            .then((resp) => {
                if (resp && resp.data && resp.data.data && resp.data.data.qty_after !== undefined) {
                    this.saldoQr = resp.data.data.qty_after;
                }
            })
            .catch((err) => {
                console.log(err);
            });
        },
        updateTable() {
            this.fetchData();
            if (this.$refs.qrReceiptFromMD && this.$refs.qrReceiptFromMD.fetchPaginated) {
                this.$refs.qrReceiptFromMD.fetchPaginated();
            }
        },
    },
}
</script>

<style scoped>
    .page-title-receipt {
        font-size: 18px;
        font-weight: 600;
        color: #2F2F2F;
        line-height: 24px;
    }

    .btn-outline-pengembalian {
        background-color: #FFFFFF !important;
        color: #F36F21 !important;
        border: 1px solid #F36F21 !important;
        border-radius: 8px !important;
        height: 32px !important;
        padding: 8px 12px !important;
        font-size: 12px !important;
        font-weight: 500 !important;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-shadow: none !important;
        cursor: pointer;
        transition: all 0.2s;
    }

    .btn-outline-pengembalian:hover {
        background-color: #FFF5EE !important;
        color: #D95D16 !important;
        border-color: #D95D16 !important;
    }

    .saldo-qr-text {
        font-size: 12px;
        color: #2F2F2F;
        font-weight: 400;
        white-space: nowrap;
    }
</style>